import { render, staticRenderFns } from "./BaseButton.vue?vue&type=template&id=cd21ed20&scoped=true&"
import script from "./BaseButton.vue?vue&type=script&lang=js&"
export * from "./BaseButton.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/base.css?vue&type=style&index=0&id=cd21ed20&prod&scoped=true&lang=css&"
import style1 from "./BaseButton.vue?vue&type=style&index=1&id=cd21ed20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd21ed20",
  null
  
)

export default component.exports